<template>
  <div class="app-page">
    <PageHeader
      type="back"
      :title="
        formData.id == 'new' ? 'Add New Review Manager' : 'Edit Review Manager'
      "
    />
    <div class="application-page-container">
      <a-form
        layout="vertical"
        ref="form"
        :model="formData"
        @finish="formFinish"
        :rules="validateRules"
      >
        <section>
          <h2 class="section-title">{{ $t('admin.Review Manager') }}</h2>
          <a-form-item
            :label="$t('admin.LLID of Review Manager')"
            name="b_LLID"
          >
            <a-input
              v-model:value="formData.b_LLID"
              :placeholder="$t('admin.Please Input')"
              :disabled="formData.id != 'new'"
            ></a-input>
          </a-form-item>
          <a-form-item
            :label="$t('admin.Review Manager Name(EN)')"
            name="b_Name"
          >
            <a-input
              v-model:value="formData.b_Name"
              :placeholder="$t('admin.Please Input')"
            ></a-input>
          </a-form-item>
          <a-form-item
            :label="$t('admin.Review Manager Email Address')"
            name="b_Email"
          >
            <a-input
              v-model:value="formData.b_Email"
              :placeholder="$t('admin.Please Input')"
            ></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Review Manager Title')" name="b_Title">
            <a-input
              v-model:value="formData.b_Title"
              :placeholder="$t('admin.Please Input')"
            ></a-input>
          </a-form-item>
          <a-form-item
            :label="$t('admin.Brand of Review Manager')"
            name="b_Brand"
          >
            <a-input
              v-model:value="formData.b_Brand"
              :placeholder="$t('admin.Please Input')"
            ></a-input>
          </a-form-item>
        </section>
        <a-form-item class="form-btn-groups">
          <a-popconfirm
            :title="
              $t('admin.If you leave before saving, your changes will be lost')
            "
            v-if="dirty"
            @confirm="$router.back"
            :okText="$t('admin.OK')"
            :cancelText="$t('admin.Cancel')"
          >
            <a-button class="btn-back">{{ $t('admin.Back') }}</a-button>
          </a-popconfirm>
          <a-button class="btn-back" @click="$router.back" v-else>
            {{ $t('admin.Back') }}
          </a-button>
          <a-button type="primary" html-type="submit" :loading="loading">
            {{ formData.id == 'new' ? $t('admin.Add') : $t('admin.Save') }}
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import PageHeader from '../components/PageHeader.vue'
import { addEmployee, updateEmployee, getMemberDetail } from '@/api/admin'
import { message } from 'ant-design-vue'
import { toRaw } from '@vue/reactivity'

export default {
  name: 'Index',
  components: {
    PageHeader,
  },
  data() {
    const validateRules = {}
    const inputFileds = ['b_LLID', 'b_Name', 'b_Title', 'b_Brand']
    const emailFields = ['b_Email']
    emailFields.map((item) => {
      validateRules[item] = [
        {
          required: true,
          message: this.$t('admin.Please Input'),
          trigger: 'blur',
        },
        {
          pattern:
            /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
          message: this.$t('admin.Incorrect mailbox format'),
        },
      ]
    })
    inputFileds.map((item) => {
      validateRules[item] = [
        {
          required: true,
          message: this.$t('admin.Please Input'),
          trigger: 'blur',
        },
      ]
    })
    return {
      loading: false,
      formData: {},
      validateRules,
      eId: null,
      dirty: false,
      popoverVisible: false,
    }
  },
  watch: {
    formData: {
      handler: function (n, o) {
        this.dirty = true
      },
      deep: true,
    },
  },
  computed: {
    dataAllReady() {
      return false
    },
  },
  created() {
    const eid = this.$route.params.id
    if (eid) {
      this.formData.id = eid
      this.eId = eid
    }
    if (eid != 'new') {
      getMemberDetail(eid).then((res) => {
        if (res.code == 200) {
          const employee = res.data

          this.formData = {
            b_LLID: employee.lion_id,
            b_Name: employee.name,
            b_Email: employee.email,
            b_Title: employee.title,
            b_Brand: employee.brand,
          }
          let that = this
          setTimeout(() => {
            that.dirty = false
          }, 50)
        }
      })
    } else {
      setTimeout(() => {
        this.dirty = false
      }, 50)
    }
  },
  methods: {
    formFinish() {
      this.loading = true
      const data = toRaw(this.formData)
      if (data.id === 'new') {
        addEmployee(data)
          .then(
            (res) => {
              this.$router.push({ path: '/master/permission/manager' })
              message.success(
                this.$t(
                  'admin.You have successfully added a new review manager.'
                )
              )
            },
            (err) => {
              message.error(err.msg)
            }
          )
          .finally(() => {
            this.loading = false
          })
      } else {
        let that = this
        updateEmployee(this.eId, data)
          .then(
            (res) => {
              message.success(
                this.$t(
                  'admin.You have successfully updated review manager information.'
                )
              )
              that.$router.push({ path: '/master/permission/manager' })
            },
            (err) => {
              message.error(err.msg)
            }
          )
          .finally(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.section-title {
  font-weight: 700;
}
.loading-small {
  margin-top: 35px;
}
@import url('@/styles/params.less');
.application-page-container {
  margin: @app-conetent-margin;
  background-color: white;
  padding: 24px;
}
.ant-form-vertical .ant-form-item {
  display: inline-block;
  width: 230px;
  margin-right: 70px;
}
.form-btn-groups {
  width: 100% !important;
  .ant-btn {
    width: 88px;
    margin-right: 16px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1440px) {
  .ant-form-item:nth-child(3n + 3) {
    margin-right: 0;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1640px) {
  .ant-form-item:nth-child(4n + 4) {
    margin-right: 0;
  }
}
</style>
